import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ProjectModal = ({ show, onClose, onSave, initialData }) => {
  // GIỮ NGUYÊN các trường và THÊM id vào state
  const [formData, setFormData] = useState({
    id: 0, // Mới: dùng để định danh khi PUT (Update)
    code: "",
    name: "",
    description: ""
  });

  // Sync data when opening modal for Edit or Add New
  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id || 0, // GIỮ NGUYÊN logic gán data và lấy thêm id
        code: initialData.code || "",
        name: initialData.name || "",
        description: initialData.description || ""
      });
    } else {
      // GIỮ NGUYÊN logic reset khi thêm mới
      setFormData({ id: 0, code: "", name: "", description: "" });
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // GIỮ NGUYÊN logic validate cũ của bạn
    if (!formData.code || !formData.name) {
      alert("Please enter both Project Code and Project Name!");
      return;
    }
    // Gửi formData bao gồm cả ID về cho hàm handleSave
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title className="small fw-bold text-uppercase">
          {initialData ? "Edit Project" : "Add New Project"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* GIỮ NGUYÊN toàn bộ các Form Group bên dưới */}
          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Project Code</Form.Label>
            <Form.Control
              type="text"
              name="code"
              size="sm"
              placeholder="e.g. PJ-2024-01"
              value={formData.code}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Project Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              size="sm"
              placeholder="Enter project name..."
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              size="sm"
              placeholder="Project details or notes..."
              value={formData.description}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <Button variant="secondary" size="sm" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" size="sm" type="submit">
            {initialData ? "Update Project" : "Save Project"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ProjectModal;